const generateColumnNames = (count : number) => {
    const columnNames : string[] = [];
    let currentLength = 1;

    while (columnNames.length < count) {
        const generateCombination = (prefix, length) => {
            const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            if (length === 0) {
                columnNames.push(prefix);
                return;
            }
            for (let i = 0; i < letters.length; i += 1) {
                generateCombination(prefix + letters[i], length - 1);
                if (columnNames.length >= count) return;
            }
        };

        generateCombination('', currentLength);
        currentLength += 1;
    }

    return columnNames;
};

export default generateColumnNames;
